import React, { useContext, useEffect, useState } from "react";
import {
  ButtonWithIcon,
  ButtonWithoutIcon,
  InputBoxWraper,
} from "../../constents/components";
import useCvUploader from "../../Hooks/Registration/useCvUploader";
import { PROFILE_URL } from "../../constents/placeholder";
import {
  PROFILE_CV_WHILE_PROFILE_EDIT_LABEL_ID,
  PROFILE_IMAGE_WHILE_PROFILE_EDIT_LABEL_ID,
} from "../../constents/htmlids";
import { MAX_PROFILE_IMAGE_SIZE } from "../../constents/numbers";
import useProfileImageUpdate from "../../Hooks/Registration/useProfileUpdater";
import useProfileDetailsUpdate from "../../Hooks/useProfileUpdator";
import IntrestEdit from "./IntrestUpdate";
import editIcon from "../../Assets/svgs/editIcon.svg";
import uploadIconDark from "../../Assets/svgs/uploadIconDark.svg";
import closeIcon from "../../Assets/svgs/closeIcon.svg";
import uploadIcon from "../../Assets/svgs/uploadIcon.svg";
import deleteIcon from "../../Assets/svgs/deleteIcon.svg";
import crossIcon from "../../Assets/svgs/closeIcon.svg";
import { ShowProfileContext } from "../../Contexts/showProfileContext";
import MobileNumberVerification from "../Auth/RegistorComponents/MobileNumberVerification";
import { useDispatch } from "react-redux";
import { USER_PROFILE_UPDATE } from "../../Utils/apis";
import { updateRegistrationStates } from "../../Store/Slices/registrationStates";

import { EDUCATION_LIST } from "../../constants/list";
import { CITY_LIST } from "../../constants/list";

const ProfileComponent = ({
  user,
  Input,
  isApplyProfileFlow = false,
  missingFields = [],
  onProfileCompleted,
}) => {
  const { closeProfile } = useContext(ShowProfileContext);
  const dispatch = useDispatch();
  const UPDATE_COUNTRY = "UPDATE_COUNTRY";
  const [showPopup, setShowPopup] = useState(false);
  const [isMobileNumberVerified, setIsMobileNumberVerified] = useState(false);
  const [mobileUpdateLoading, setMobileUpdateLoading] = useState(false);
  const [mobileUpdateError, setMobileUpdateError] = useState("");
  const [isCityDropdownOpen, setIsCityDropdownOpen] = useState(false);
  const [isEducationDropdownOpen, setIsEducationDropdownOpen] = useState(false);
  const [isEditable, setIsEditable] = useState(isApplyProfileFlow);
  const [newProfieUrl, setNewProfileUrl] = useState("");
  const [newProfileError, setNewProfileError] = useState("");
  const [
    userImageUploading,
    userImageError,
    userImageUrl,
    userImageUploadFunction,
  ] = useProfileImageUpdate();
  const [
    profileDetailsLoading,
    profileDetailsError,
    profileDetailsUploadFunction,
  ] = useProfileDetailsUpdate();

  const [
    resumeLoading,
    resumeError,
    isFileUploaded,
    cvUploaderFunction,
    resumeUrl,
  ] = useCvUploader();

  const registrationData = JSON.parse(
    sessionStorage.getItem("registrationFromData") || "{}",
  );

  const [values, setValues] = useState({
    profileUrl: user?.profile_url || PROFILE_URL,
    firstName: user?.first_name,
    lastName: user?.last_name,
    gender: user?.gender,
    mobile: user?.mobile,
    designation: user?.designation,
    location: user?.location || registrationData.location || "",
    city: user?.city || registrationData?.city || "",
    education: user?.education || registrationData?.education || "",
    years_of_experience:
      user?.years_of_experience ?? registrationData?.years_of_experience ?? 0,
    country: user?.country || "",
    cvUrl: user?.resume_url,
    linkedin: user?.handles?.Linkedin,
    interest: user?.preffered_job_types || [],
    expected_ctc: user?.expected_ctc,
    current_ctc: user?.current_ctc,
    profile: {},
    jobIndustry: user?.job_industry || "",
    handles: {
      Github: user?.handles?.Github || "",
      Linkedin: user?.handles?.Linkedin || "",
      Twitter: user?.handles?.Twitter || "",
      Other_Handles: user?.handles?.Other_Handles || "",
    },
  });

  const filteredCities = CITY_LIST.filter((city) =>
    city.toLowerCase().includes((values.city || "").toLowerCase()),
  );

  const filteredEducation = EDUCATION_LIST.filter((education) =>
    education.toLowerCase().includes((values.education || "").toLowerCase()),
  );

  const changes = {
    firstName: (text) => {
      setValues((pre) => {
        return { ...pre, firstName: text };
      });
    },
    mobile: (text) => {
      setValues((pre) => {
        return { ...pre, mobile: text };
      });
    },
    lastName: (text) => {
      setValues((pre) => {
        return { ...pre, lastName: text };
      });
    },
    designation: (text) => {
      setValues((pre) => {
        return { ...pre, designation: text };
      });
    },
    city: (text) => {
      setValues((pre) => {
        return { ...pre, city: text };
      });
    },
    education: (text) => {
      setValues((pre) => {
        return { ...pre, education: text };
      });
    },
    years_of_experience: (value) => {
      setValues((prev) => ({
        ...prev,
        years_of_experience: value === "" ? "" : Number(value),
      }));
    },
    location: (text) => {
      setValues((pre) => {
        return { ...pre, location: text };
      });
    },
    country: (text) => {
      setValues((pre) => {
        return { ...pre, country: text };
      });
    },
    linkedin: (text) => {
      setValues((pre) => {
        return {
          ...pre,
          linkedin: text,
          handles: { ...pre.handles, Linkedin: text },
        };
      });
    },
    expected_ctc: (text) => {
      setValues((pre) => {
        return { ...pre, expected_ctc: text };
      });
    },
    current_ctc: (text) => {
      setValues((pre) => {
        return { ...pre, current_ctc: text };
      });
    },
    gender: (text) => {
      setValues((pre) => {
        return { ...pre, gender: text };
      });
    },
    updateProfile: (value) => {
      setValues((pre) => {
        return { ...pre, profile: value };
      });
    },
    updateIntrest: (list) => {
      setValues((pre) => {
        return { ...pre, interest: list };
      });
    },
    updateJobIndustry: (text) => {
      setValues((pre) => {
        return { ...pre, jobIndustry: text };
      });
    },
  };

  useEffect(() => {
    if (resumeUrl) {
      setValues((pre) => ({ ...pre, cvUrl: resumeUrl }));
    }
  }, [resumeUrl]);

  useEffect(() => {
    if (isApplyProfileFlow) {
      setIsEditable(true);
    }
  }, [isApplyProfileFlow]);

  const placeholders = {
    firstName: "First Name",
    lastName: "Last Name",
    gender: "Select your gender",
    designation: "Your Current Designation",
    city: "Your City",
    education: "Your Education",
    country: "Your Country",
    linkedin: "Linkedin profile link",
    interest: "Select your interest",
    expected_ctc: "Expected CTC per year",
    current_ctc: "Current CTC per year",
  };

  const isMissingField = (field) => {
    return missingFields?.includes(field);
  };

  const genderOptions = ["Male", "Female"];

  const updateCountry = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_COUNTRY, payload: value }),
    );

  const onSaveClick = async () => {
    try {
      await profileDetailsUploadFunction(values);

      if (values?.profile?.size) {
        await userImageUploadFunction(values.profile);
      }

      setIsEditable(false);

      if (isApplyProfileFlow && onProfileCompleted) {
        closeProfile();
        onProfileCompleted();
        return;
      }

      setIsEditable(false);
    } catch (error) {
      console.error("Profile update failed:", error);
    }
  };

  const onEditClick = () => setIsEditable(true);

  const onEditMobileClick = () => setShowPopup(true);

  const updateMobileNumber = async () => {
    if (!values.mobile) {
      setMobileUpdateError("Please enter a mobile number");
      return;
    }

    if (!isMobileNumberVerified) {
      setMobileUpdateError("Please verify your mobile number first");
      return;
    }

    try {
      setMobileUpdateLoading(true);
      setMobileUpdateError("");

      const res = await fetch(USER_PROFILE_UPDATE, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          mobile: values.mobile,
        }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || "Failed to update mobile number");
      }

      setShowPopup(false);
      setIsMobileNumberVerified(false);
    } catch (error) {
      setMobileUpdateError(error.message);
    } finally {
      setMobileUpdateLoading(false);
    }
  };

  const profieChanger = (file) => {
    setNewProfileError("");

    if (file?.size) {
      if (file.size >= MAX_PROFILE_IMAGE_SIZE) {
        setNewProfileError(
          `File size should be under ${MAX_PROFILE_IMAGE_SIZE / 1024}KB`,
        );
      } else {
        changes.updateProfile(file);
        setNewProfileUrl(URL.createObjectURL(file));
      }
    }
  };

  const onRemoveProfile = () => {
    changes.updateProfile("");
    setNewProfileUrl("");
  };

  useEffect(() => {
    if (user) {
      setValues((prev) => ({
        ...prev,
        city: user.city || registrationData?.city || "",
        education: user.education || registrationData?.education || "",
        location: user.location || registrationData?.location || "",
        country: user.country || "",
      }));
    }
  }, [
    user?.city,
    user?.education,
    user?.location,
    user?.country,
    registrationData?.city,
    registrationData?.education,
  ]);

  return (
    <div className="flex flex-col w-full gap-2 p-2 pb-16 md:p-4 lg:p-6">
      <div className="flex items-center justify-end gap-2 text-center ">
        <ButtonWithIcon
          inversed={true}
          icon={editIcon}
          onButtonClick={onEditMobileClick}
          text={"Edit Mobile Number"}
          classNames="px-4 py-2 border-[0.01rem] border-pills-border-color-900"
        />

        {!isEditable ? (
          <>
            <ButtonWithIcon
              inversed={true}
              icon={editIcon}
              onButtonClick={onEditClick}
              text={"Edit Profile"}
              classNames="px-4 py-2 border-[0.01rem] border-pills-border-color-900"
            />

            <img
              className="w-8 cursor-pointer "
              onClick={() => closeProfile()}
              src={closeIcon}
            />
          </>
        ) : (
          <div className="flex justify-end gap-2 ">
            <ButtonWithoutIcon
              text={"Cancel"}
              inversed={true}
              classNames={`px-6 py-2 border-pills-border-color-900 border-[1px]`}
              onButtonClick={() => setIsEditable(false)}
            />

            <ButtonWithoutIcon
              text={profileDetailsLoading ? "saving..." : "Save"}
              classNames={`px-6 py-2 text-white ${
                profileDetailsLoading && " cursor-not-allowed"
              }`}
              onButtonClick={onSaveClick}
            />
          </div>
        )}
      </div>

      <p className="mb-1 font-semibold ">Profile</p>

      <div className="flex flex-col items-start my-1">
        <div className="flex items-center justify-between w-full gap-2">
          <div className="flex items-center gap-2">
            <img
              src={newProfieUrl || values.profileUrl}
              className="w-10 rounded-full lg:w-16 aspect-square"
              alt="user profile image"
            />

            {isEditable && <p className="text-sm ">Max size 500kb</p>}
          </div>

          {isEditable && (
            <div className="flex items-center gap-2">
              <div className="flex flex-col gap-1 ">
                <label
                  className="flex gap-1 px-4 py-2 text-white bg-black rounded-full cursor-pointer "
                  htmlFor={PROFILE_IMAGE_WHILE_PROFILE_EDIT_LABEL_ID}
                >
                  <img src={uploadIcon} className="w-4" alt="uploadIcon" />
                  <span className="text-sm ">Upload New Photo</span>
                </label>

                <input
                  className="hidden"
                  id={PROFILE_IMAGE_WHILE_PROFILE_EDIT_LABEL_ID}
                  type="file"
                  onChange={(e) => profieChanger(e.target.files[0])}
                />

                {(newProfileError || userImageError) && (
                  <p className="text-red-400 ">
                    {userImageError ?? newProfileError}
                  </p>
                )}
              </div>

              <div
                onClick={() => onRemoveProfile()}
                className="cursor-pointer h-6 aspect-square flex items-center justify-center rounded-full border-[1px] border-pills-border-color-900"
              >
                <img
                  src={deleteIcon}
                  className="h-4 aspect-square"
                  alt="deleteIcon"
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* First Name */}
      <div className="flex-1">
        <p className="mb-1 font-semibold">First Name</p>

        <InputBoxWraper classnames={"flex-1"}>
          <Input
            isEditable={isEditable}
            change={(text) => changes.firstName(text)}
            value={values.firstName}
            placeholder={placeholders.firstName}
          />
        </InputBoxWraper>
      </div>

      {/* Last Name */}
      <div className="flex-1">
        <p className="mb-1 font-semibold">Last Name</p>

        <InputBoxWraper>
          <Input
            isEditable={isEditable}
            change={(text) => changes.lastName(text)}
            value={values.lastName}
            placeholder={placeholders.lastName}
          />
        </InputBoxWraper>
      </div>

      <div className="mt-2">
        <p className="mb-1 font-semibold">Select Your Gender</p>

        <InputBoxWraper classnames={"flex-1"}>
          {isEditable ? (
            <select
              onChange={(e) => changes.gender(e.target.value)}
              className="w-full bg-transparent border-none outline-none "
            >
              {genderOptions?.map((item, index) => (
                <option
                  className=""
                  key={index}
                  selected={item === values?.gender}
                >
                  {item}
                </option>
              ))}
            </select>
          ) : (
            <p>{values.gender}</p>
          )}
        </InputBoxWraper>
      </div>

      {/* City */}
      <div className="relative w-full">
        <p className="mb-1 font-semibold">City</p>

        <InputBoxWraper
          classnames={`w-full ${
            isMissingField("city") ? "border-2 border-red-500 bg-red-50" : ""
          }`}
        >
          <input
            type="text"
            className="bg-transparent outline-none border-none w-full"
            placeholder="Enter city"
            value={values.city || ""}
            disabled={!isEditable}
            onFocus={() => {
              if (isEditable) {
                setIsCityDropdownOpen(true);
              }
            }}
            onChange={(e) => {
              setValues((prev) => ({
                ...prev,
                city: e.target.value,
              }));

              setIsCityDropdownOpen(true);
            }}
          />

          {isEditable && (
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                setIsCityDropdownOpen((prev) => !prev);
              }}
              className="flex items-center justify-center"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`transition-transform duration-200 ${
                  isCityDropdownOpen ? "rotate-180" : ""
                }`}
              >
                <path
                  d="M7 10L12 15L17 10"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </InputBoxWraper>

        {isMissingField("city") && (
          <p className="mt-1 text-xs font-medium text-red-500">
            Please complete this field
          </p>
        )}

        {isEditable && isCityDropdownOpen && (
          <div className="absolute left-0 right-0 top-full z-50 mt-1 max-h-60 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
            {filteredCities.map((city) => (
              <button
                key={city}
                type="button"
                className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100"
                onMouseDown={(e) => {
                  e.preventDefault();

                  setValues((prev) => ({
                    ...prev,
                    city: city,
                  }));

                  setIsCityDropdownOpen(false);
                }}
              >
                {city}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Location */}
      <div className="w-full mt-4">
        <p className="mb-1 font-semibold">Location</p>

        <InputBoxWraper
          classnames={`w-full ${isMissingField("location") ? "border-2 border-red-500 bg-red-50" : ""}`}
        >
          <Input
            isEditable={isEditable}
            change={(text) => changes.location(text)}
            value={values.location || ""}
            placeholder="Your Location"
          />
        </InputBoxWraper>
        {isMissingField("location") && (
          <p className="mt-1 text-xs font-medium text-red-500">
            Please complete this field
          </p>
        )}
      </div>

      {/* Country */}
      <div className="w-full mt-4">
        <p className="mb-1 font-semibold">Country</p>

        <InputBoxWraper
          classnames={`w-full ${isMissingField("country") ? "border-2 border-red-500 bg-red-50" : ""}`}
        >
          <Input
            isEditable={isEditable}
            change={(text) => changes.country(text)}
            value={values.country}
            placeholder={placeholders.country}
          />
        </InputBoxWraper>
        {isMissingField("country") && (
          <p className="mt-1 text-xs font-medium text-red-500">
            Please complete this field
          </p>
        )}
      </div>

      <p className="mb-1 font-semibold ">Professional Details</p>

      {/* Education */}
      <div className="relative">
        <p className="mb-1 font-semibold">Education</p>

        <InputBoxWraper
          classnames={`w-full ${isMissingField("education") ? "border-2 border-red-500 bg-red-50" : ""}`}
        >
          <input
            type="text"
            className="bg-transparent outline-none border-none w-full"
            placeholder="Enter your highest education"
            value={values.education || ""}
            onFocus={() => {
              if (isEditable) {
                setIsEducationDropdownOpen(true);
              }
            }}
            onChange={(e) => {
              setValues((prev) => ({
                ...prev,
                education: e.target.value,
              }));

              setIsEducationDropdownOpen(true);
            }}
            disabled={!isEditable}
          />

          {isEditable && (
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();

                setIsEducationDropdownOpen((prev) => !prev);
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M7 10L12 15L17 10"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </InputBoxWraper>

        {isMissingField("education") && (
          <p className="mt-1 text-xs font-medium text-red-500">
            Please complete this field
          </p>
        )}

        {isEditable && isEducationDropdownOpen && (
          <div className="absolute left-0 right-0 top-full z-50 mt-1 max-h-60 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
            {filteredEducation.map((education) => (
              <button
                key={education}
                type="button"
                className="block w-full px-4 py-2 text-left hover:bg-gray-100"
                onMouseDown={(e) => {
                  e.preventDefault();

                  setValues((prev) => ({
                    ...prev,
                    education,
                  }));

                  setIsEducationDropdownOpen(false);
                }}
              >
                {education}
              </button>
            ))}

            {!EDUCATION_LIST.some(
              (education) =>
                education.toLowerCase() ===
                (values.education || "").trim().toLowerCase(),
            ) &&
              values.education?.trim() && (
                <button
                  type="button"
                  className="block w-full border-t border-gray-200 px-4 py-2 text-left font-medium hover:bg-gray-100"
                  onMouseDown={(e) => {
                    e.preventDefault();

                    setValues((prev) => ({
                      ...prev,
                      education: values.education,
                    }));

                    setIsEducationDropdownOpen(false);
                  }}
                >
                  Other (enter your education)
                </button>
              )}
          </div>
        )}
      </div>

      {/* Designation */}
      <div className="flex-1">
        <p className="mb-1 font-semibold">Current Designation</p>

        <InputBoxWraper
          classnames={`flex-1 ${isMissingField("designation") ? "border-2 border-red-500 bg-red-50" : ""}`}
        >
          <Input
            isEditable={isEditable}
            change={(text) => changes.designation(text)}
            value={values.designation}
            placeholder={placeholders.designation}
          />
        </InputBoxWraper>
        {isMissingField("designation") && (
          <p className="mt-1 text-xs font-medium text-red-500">
            Please complete this field
          </p>
        )}
      </div>

      {/* Years of Experience */}
      <div className="w-full">
        <p className="mb-1 font-semibold">Years of Experience</p>

        <InputBoxWraper
          classnames={`w-full ${isMissingField("years_of_experience") ? "border-2 border-red-500 bg-red-50" : ""}`}
        >
          <Input
            type="number"
            min="0"
            step="1"
            isEditable={isEditable}
            change={(value) => changes.years_of_experience(value)}
            value={values.years_of_experience ?? ""}
            placeholder="Years of Experience"
          />
        </InputBoxWraper>
        {isMissingField("years_of_experience") && (
          <p className="mt-1 text-xs font-medium text-red-500">
            Please complete this field
          </p>
        )}
      </div>

      <div>
        <p className="mb-1 font-semibold">Current CTC</p>
        <InputBoxWraper
          classnames={`flex-1 ${isMissingField("current_ctc") ? "border-2 border-red-500 bg-red-50" : ""}`}
        >
          <Input
            isEditable={isEditable}
            change={(text) => changes.current_ctc(text)}
            value={values.current_ctc}
            placeholder={placeholders.current_ctc}
            type="number"
          />
        </InputBoxWraper>
        {isMissingField("current_ctc") && (
          <p className="mt-1 text-xs font-medium text-red-500">
            Please complete this field
          </p>
        )}
      </div>

      <div>
        <p className="mb-1 font-semibold">Expected CTC</p>
        <InputBoxWraper
          classnames={`flex-1 ${isMissingField("expected_ctc") ? "border-2 border-red-500 bg-red-50" : ""}`}
        >
          <Input
            isEditable={isEditable}
            change={(text) => changes.expected_ctc(text)}
            value={values.expected_ctc}
            placeholder={placeholders.expected_ctc}
            type="number"
          />
        </InputBoxWraper>
        {isMissingField("expected_ctc") && (
          <p className="mt-1 text-xs font-medium text-red-500">
            Please complete this field
          </p>
        )}
      </div>

      <p className="mb-1 font-semibold ">Setup your CV</p>

      {isEditable ? (
        <>
          <input
            type="file"
            id={PROFILE_CV_WHILE_PROFILE_EDIT_LABEL_ID}
            className="hidden w-full "
            onChange={(e) => {
              cvUploaderFunction(e.target.files[0]);
            }}
          />

          <label
            className={`cursor-pointer flex items-center justify-center gap-2 min-h-24 font-semibold rounded-md border-2 border-dashed ${
              isMissingField("resume_url")
                ? "border-red-500 bg-red-50"
                : "border-primary-color-900"
            }`}
            htmlFor={PROFILE_CV_WHILE_PROFILE_EDIT_LABEL_ID}
          >
            <div className="flex items-center justify-center w-8 rounded-full aspect-square bg-pills-bg-color-900">
              <img src={uploadIconDark} className="w-4" alt="uploadIcon" />
            </div>
            Upload Your CV
          </label>

          {isMissingField("resume_url") && (
            <p className="mt-1 text-xs font-medium text-red-500">
              Please upload your resume
            </p>
          )}

          {resumeError && <p className="text-red-400 ">{resumeError}</p>}
          {resumeLoading && <p className="text-black ">{"Uploding cv"}</p>}
          {isFileUploaded && (
            <p className="text-red-400 ">{"Cv updated successfully"}</p>
          )}
        </>
      ) : (
        <InputBoxWraper>
          <span onClick={() => window.open(values.cvUrl, "_blank")}>
            Your CV
          </span>
        </InputBoxWraper>
      )}

      <InputBoxWraper classnames={"w-full"}>
        <Input
          isEditable={isEditable}
          change={(text) => changes.linkedin(text)}
          value={values.linkedin}
          placeholder={placeholders.linkedin}
        />
      </InputBoxWraper>

      <p className="mb-1 font-semibold ">Area of interest</p>

      <div className="flex flex-wrap gap-4 ">
        {isEditable ? (
          <IntrestEdit
            values={values.interest}
            updateIntrest={(list) => changes.updateIntrest(list)}
            updateJobIndustry={(text) => changes.updateJobIndustry(text)}
          />
        ) : (
          values?.interest?.map((item, index) => (
            <span
              className="flex items-center justify-center gap-2 p-2 px-4 rounded-md bg-pills-bg-color-900"
              key={index}
            >
              {item}
            </span>
          ))
        )}
      </div>

      {isEditable && (
        <div className="flex justify-end gap-2 mt-4 ">
          <ButtonWithoutIcon
            text={"Cancel"}
            inversed={true}
            classNames={`px-6 py-1 border-pills-border-color-900 border-[1px]`}
            onButtonClick={() => setIsEditable(false)}
          />

          <ButtonWithoutIcon
            text={profileDetailsLoading ? "saving..." : "Save"}
            classNames={`px-6 py-1 text-white ${
              profileDetailsLoading && " cursor-not-allowed"
            }`}
            onButtonClick={onSaveClick}
          />
        </div>
      )}

      {showPopup && (
        <div className="bg-opacity-50 backdrop-blur-sm fixed bg-transparent h-screen w-screen z-[100] bg-[#F8F8F8] left-0 right-0 top-0 bottom-0 p-4 rounded-md flex items-center justify-center">
          <div className="relative p-6 text-center bg-white shadow-lg rounded-2xl w-96">
            <button
              className="absolute top-4 right-4"
              onClick={() => {
                setShowPopup(false);
              }}
            >
              <img src={crossIcon} alt="Close" className="w-5 h-5" />
            </button>

            <div className="flex justify-center mb-2"></div>

            <MobileNumberVerification
              updateCountry={updateCountry}
              updateMobile={(value) => changes.mobile(value)}
              flag={false}
              mobile={values.mobile}
              email={user?.email}
              isMobileNumberVerified={isMobileNumberVerified}
              setIsMobileNumberVerified={setIsMobileNumberVerified}
            />

            {/* {isMobileNumberVerified && (
              <p className="mt-2 text-green-600 ">
                Mobile number verified successfully!
              </p>
            )} */}

            {mobileUpdateError && (
              <p className="mt-2 text-sm text-red-500">{mobileUpdateError}</p>
            )}

            <ButtonWithoutIcon
              text={
                mobileUpdateLoading ? "Updating..." : "Update Mobile Number"
              }
              classNames={`w-full mt-4 py-2 text-white ${
                mobileUpdateLoading ? "cursor-not-allowed opacity-60" : ""
              }`}
              onButtonClick={updateMobileNumber}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileComponent;
